import Vue from 'vue'
import App from './App.vue'
import HappyBdayJsal from './HappyBdayJsal.vue';
import isJsalBday from './utils/isJsalBday';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

const renderableView = isJsalBday() ? HappyBdayJsal : App

new Vue({
  render: h => h(renderableView),
  vuetify,
}).$mount('#app')
